import {TTrack} from "../types";
import API from "./api";

export async function getTrackHistory(): Promise<Array<TTrack>> {
    return API.get("/api/tracks/history",).then((response) => {
        return Promise.resolve(response.data as Array<TTrack>);
    }).catch(error => {
        return Promise.reject(error);
    });

};